import { render, staticRenderFns } from "./TaskManagerView.vue?vue&type=template&id=7bccb95e"
import script from "./TaskManagerView.vue?vue&type=script&lang=js"
export * from "./TaskManagerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports